// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 9ca3sE4gAMHXGHWcmrUodR
// Component: 5Pxe45fpZL
import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import Button from "../../Button"; // plasmic-import: aLOScdJViiG/component

import { useScreenVariants as useScreenVariantsyIaqVJpcFs0Ua } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: YIaqVJpcFs0UA/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic_main.module.css"; // plasmic-import: 9ca3sE4gAMHXGHWcmrUodR/projectcss
import sty from "./PlasmicNavbar.module.css"; // plasmic-import: 5Pxe45fpZL/css

import ChecksvgIcon from "./icons/PlasmicIcon__Checksvg"; // plasmic-import: YgxDZcg-ug-/icon
import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: tWUxgGBbs9p/icon
import imageWlrG2Qk0Ne9 from "./images/image.svg"; // plasmic-import: wlrG2qk0ne9/picture

export type PlasmicNavbar__VariantMembers = {
  state: "loggedOut" | "loggedIn";
};

export type PlasmicNavbar__VariantsArgs = {
  state?: SingleChoiceArg<"loggedOut" | "loggedIn">;
};

type VariantPropType = keyof PlasmicNavbar__VariantsArgs;
export const PlasmicNavbar__VariantProps = new Array<VariantPropType>("state");

export type PlasmicNavbar__ArgsType = {
  children?: React.ReactNode;
};

type ArgPropType = keyof PlasmicNavbar__ArgsType;
export const PlasmicNavbar__ArgProps = new Array<ArgPropType>("children");

export type PlasmicNavbar__OverridesType = {
  root?: p.Flex<"div">;
  header?: p.Flex<"div">;
  logo?: p.Flex<typeof p.PlasmicImg>;
  brand?: p.Flex<"div">;
  requestFeatures?: p.Flex<typeof Button>;
  logOut?: p.Flex<typeof Button>;
  logIn?: p.Flex<typeof Button>;
  signUp?: p.Flex<typeof Button>;
  userLetter?: p.Flex<"div">;
};

export interface DefaultNavbarProps {
  children?: React.ReactNode;
  state?: SingleChoiceArg<"loggedOut" | "loggedIn">;
  className?: string;
}

function PlasmicNavbar__RenderFunc(props: {
  variants: PlasmicNavbar__VariantsArgs;
  args: PlasmicNavbar__ArgsType;
  overrides: PlasmicNavbar__OverridesType;

  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const $ctx = ph.useDataEnv?.() || {};
  const args = React.useMemo(
    () =>
      Object.assign(
        {},

        props.args
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const currentUser = p.useCurrentUser?.() || {};

  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantsyIaqVJpcFs0Ua()
  });

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root
      )}
    >
      <p.Stack
        as={"div"}
        hasGap={true}
        className={classNames(projectcss.all, sty.freeBox__yvMrx, {
          [sty.freeBoxstate_loggedIn__yvMrx97Luw]: hasVariant(
            variants,
            "state",
            "loggedIn"
          )
        })}
      >
        <p.Stack
          as={"div"}
          hasGap={true}
          className={classNames(projectcss.all, sty.freeBox__i5Px, {
            [sty.freeBoxstate_loggedIn__i5Px97Luw]: hasVariant(
              variants,
              "state",
              "loggedIn"
            )
          })}
        >
          {true ? (
            <div
              data-plasmic-name={"header"}
              data-plasmic-override={overrides.header}
              className={classNames(projectcss.all, sty.header)}
            >
              <p.PlasmicImg
                data-plasmic-name={"logo"}
                data-plasmic-override={overrides.logo}
                alt={""}
                className={classNames(sty.logo)}
                displayHeight={"40px" as const}
                displayMaxHeight={"none" as const}
                displayMaxWidth={"none" as const}
                displayMinHeight={"0" as const}
                displayMinWidth={"0" as const}
                displayWidth={"40px" as const}
                src={{
                  src: imageWlrG2Qk0Ne9,
                  fullWidth: 150,
                  fullHeight: 150,
                  aspectRatio: 1
                }}
              />

              <div
                data-plasmic-name={"brand"}
                data-plasmic-override={overrides.brand}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.brand
                )}
              >
                <React.Fragment>
                  <span
                    className={"plasmic_default__all plasmic_default__span"}
                    style={{ fontWeight: 700 }}
                  >
                    {"BIMMY"}
                  </span>
                </React.Fragment>
              </div>
            </div>
          ) : null}

          <p.Stack
            as={"div"}
            hasGap={true}
            className={classNames(projectcss.all, sty.freeBox__uxUaO)}
          >
            {(hasVariant(variants, "state", "loggedIn") ? true : true) ? (
              <div
                className={classNames(projectcss.all, sty.freeBox___11PsN, {
                  [sty.freeBoxstate_loggedIn___11PsN97Luw]: hasVariant(
                    variants,
                    "state",
                    "loggedIn"
                  )
                })}
              >
                <button
                  className={classNames(
                    projectcss.all,
                    projectcss.button,
                    projectcss.__wab_text,
                    sty.button__bxg
                  )}
                >
                  {"Sign up"}
                </button>

                {true ? (
                  <Button
                    className={classNames("__wab_instance", sty.button__fYmw6)}
                    color={"clear" as const}
                    endIcon={
                      <IconIcon
                        className={classNames(projectcss.all, sty.svg___0Bk6E)}
                        role={"img"}
                      />
                    }
                    startIcon={
                      <ChecksvgIcon
                        className={classNames(projectcss.all, sty.svg__e24If)}
                        role={"img"}
                      />
                    }
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__xftW1
                      )}
                    >
                      {"Log in"}
                    </div>
                  </Button>
                ) : null}
              </div>
            ) : null}

            <Button
              className={classNames("__wab_instance", sty.button__mwqGk)}
              color={"clear" as const}
              endIcon={
                <IconIcon
                  className={classNames(projectcss.all, sty.svg__yFPD)}
                  role={"img"}
                />
              }
              startIcon={
                <ChecksvgIcon
                  className={classNames(projectcss.all, sty.svg__ostTa)}
                  role={"img"}
                />
              }
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text___0L6VI
                )}
              >
                {"Blog"}
              </div>
            </Button>

            <Button
              data-plasmic-name={"requestFeatures"}
              data-plasmic-override={overrides.requestFeatures}
              className={classNames("__wab_instance", sty.requestFeatures)}
              color={"clear" as const}
              endIcon={
                <IconIcon
                  className={classNames(projectcss.all, sty.svg__pX4Jv)}
                  role={"img"}
                />
              }
              startIcon={
                <ChecksvgIcon
                  className={classNames(projectcss.all, sty.svg__crhkC)}
                  role={"img"}
                />
              }
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__iNJ5
                )}
              >
                {"Request Feature"}
              </div>
            </Button>

            {(
              hasVariant(variants, "state", "loggedIn")
                ? true
                : hasVariant(variants, "state", "loggedOut")
                ? true
                : true
            ) ? (
              <Button
                data-plasmic-name={"logOut"}
                data-plasmic-override={overrides.logOut}
                className={classNames("__wab_instance", sty.logOut, {
                  [sty.logOutstate_loggedIn]: hasVariant(
                    variants,
                    "state",
                    "loggedIn"
                  ),
                  [sty.logOutstate_loggedOut]: hasVariant(
                    variants,
                    "state",
                    "loggedOut"
                  )
                })}
                color={"clear" as const}
                endIcon={
                  <IconIcon
                    className={classNames(projectcss.all, sty.svg__yg7Y6)}
                    role={"img"}
                  />
                }
                startIcon={
                  <ChecksvgIcon
                    className={classNames(projectcss.all, sty.svg__lgQzH)}
                    role={"img"}
                  />
                }
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__dMgi4
                  )}
                >
                  {"Log Out"}
                </div>
              </Button>
            ) : null}
            {(hasVariant(variants, "state", "loggedIn") ? true : true) ? (
              <Button
                data-plasmic-name={"logIn"}
                data-plasmic-override={overrides.logIn}
                className={classNames("__wab_instance", sty.logIn, {
                  [sty.logInstate_loggedIn]: hasVariant(
                    variants,
                    "state",
                    "loggedIn"
                  )
                })}
                color={"clear" as const}
                endIcon={
                  <IconIcon
                    className={classNames(projectcss.all, sty.svg__jOLm9)}
                    role={"img"}
                  />
                }
                startIcon={
                  <ChecksvgIcon
                    className={classNames(projectcss.all, sty.svg__zvkCx)}
                    role={"img"}
                  />
                }
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__oruOf
                  )}
                >
                  {"Log in"}
                </div>
              </Button>
            ) : null}
            {(hasVariant(variants, "state", "loggedIn") ? true : true) ? (
              <Button
                data-plasmic-name={"signUp"}
                data-plasmic-override={overrides.signUp}
                className={classNames("__wab_instance", sty.signUp, {
                  [sty.signUpstate_loggedIn]: hasVariant(
                    variants,
                    "state",
                    "loggedIn"
                  ),
                  [sty.signUpstate_loggedOut]: hasVariant(
                    variants,
                    "state",
                    "loggedOut"
                  )
                })}
                endIcon={
                  <IconIcon
                    className={classNames(projectcss.all, sty.svg__mNkVk)}
                    role={"img"}
                  />
                }
                startIcon={
                  <ChecksvgIcon
                    className={classNames(projectcss.all, sty.svg__qhRl8)}
                    role={"img"}
                  />
                }
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text___9P5CL
                  )}
                >
                  {"Sign up"}
                </div>
              </Button>
            ) : null}
            {(hasVariant(variants, "state", "loggedIn") ? true : true) ? (
              <div
                className={classNames(projectcss.all, sty.freeBox__hknrs, {
                  [sty.freeBoxstate_loggedIn__hknrs97Luw]: hasVariant(
                    variants,
                    "state",
                    "loggedIn"
                  )
                })}
              >
                <div
                  data-plasmic-name={"userLetter"}
                  data-plasmic-override={overrides.userLetter}
                  className={classNames(projectcss.all, sty.userLetter)}
                >
                  {p.renderPlasmicSlot({
                    defaultContents: "V",
                    value: args.children,
                    className: classNames(sty.slotTargetChildren, {
                      [sty.slotTargetChildrenstate_loggedIn]: hasVariant(
                        variants,
                        "state",
                        "loggedIn"
                      )
                    })
                  })}
                </div>
              </div>
            ) : null}
          </p.Stack>
        </p.Stack>
      </p.Stack>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "header",
    "logo",
    "brand",
    "requestFeatures",
    "logOut",
    "logIn",
    "signUp",
    "userLetter"
  ],
  header: ["header", "logo", "brand"],
  logo: ["logo"],
  brand: ["brand"],
  requestFeatures: ["requestFeatures"],
  logOut: ["logOut"],
  logIn: ["logIn"],
  signUp: ["signUp"],
  userLetter: ["userLetter"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  typeof PlasmicDescendants[T][number];
type NodeDefaultElementType = {
  root: "div";
  header: "div";
  logo: typeof p.PlasmicImg;
  brand: "div";
  requestFeatures: typeof Button;
  logOut: typeof Button;
  logIn: typeof Button;
  signUp: typeof Button;
  userLetter: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicNavbar__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicNavbar__VariantsArgs;
    args?: PlasmicNavbar__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicNavbar__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicNavbar__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicNavbar__ArgProps,
          internalVariantPropNames: PlasmicNavbar__VariantProps
        }),
      [props, nodeName]
    );

    return PlasmicNavbar__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicNavbar";
  } else {
    func.displayName = `PlasmicNavbar.${nodeName}`;
  }
  return func;
}

export const PlasmicNavbar = Object.assign(
  // Top-level PlasmicNavbar renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    header: makeNodeComponent("header"),
    logo: makeNodeComponent("logo"),
    brand: makeNodeComponent("brand"),
    requestFeatures: makeNodeComponent("requestFeatures"),
    logOut: makeNodeComponent("logOut"),
    logIn: makeNodeComponent("logIn"),
    signUp: makeNodeComponent("signUp"),
    userLetter: makeNodeComponent("userLetter"),

    // Metadata about props expected for PlasmicNavbar
    internalVariantProps: PlasmicNavbar__VariantProps,
    internalArgProps: PlasmicNavbar__ArgProps
  }
);

export default PlasmicNavbar;
/* prettier-ignore-end */
